import FormattedMessage from 'I18n/components/FormattedMessage';
import HomepageHighlightedMember from './HomepageHighlightedMember';
// @ts-expect-error ts-migrate(7016) NOFIX
import avatarImage from 'bender-url!../../../../images/highlightedMembers/ali-schwanke.png';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AliSchwanke({
  avatarSize
}) {
  return /*#__PURE__*/_jsx(HomepageHighlightedMember, {
    displayName: "Ali Schwanke",
    roleText: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.homepage.memberHighlight.members.aliSchwanke.role"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.homepage.memberHighlight.members.aliSchwanke.role2"
      })]
    }),
    avatarSrc: avatarImage,
    avatarSize: avatarSize
  });
}